import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['slide', 'progressDot', 'cta'];
  static values = {
    currentSlide: { type: Number, default: 0 },
    totalSlides: { type: Number, default: 5 },
  };

  connect() {
    this.showSlide(0);
  }

  next() {
    if (this.currentSlideValue < this.totalSlidesValue - 1) {
      this.showSlide(this.currentSlideValue + 1);
    }
  }

  goToSlide(event) {
    const index = parseInt(event.currentTarget.dataset.slideIndex, 10);

    this.showSlide(index);
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        slide.classList.remove('hidden');
      } else {
        slide.classList.add('hidden');
      }
    });

    if (this.hasCtaTarget) {
      this.ctaTargets.forEach((cta, i) => {
        if (i === index) {
          cta.classList.remove('hidden');
        } else {
          cta.classList.add('hidden');
        }
      });
    }

    this.progressDotTargets.forEach((dot, i) => {
      if (i <= index) {
        dot.classList.add('bg-primary');
        dot.classList.remove('bg-gray-200');
      } else {
        dot.classList.remove('bg-primary');
        dot.classList.add('bg-gray-200');
      }
    });

    this.currentSlideValue = index;
  }
}
